import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'credor'
})
export class CredorPipe implements PipeTransform {

  transform(value: number, args?: any): any {
    if (value !== undefined) {
      const strValue = value + '';
      return strValue.replace(/(\d{4})(\d{5})(\d{1})/g, '\$1.\$2\-\$3');
    } else {
      return value;
    }
    
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipe/credor.pipe.ts